export const refObjects = {
'ayvakit_cs':[20,22,],
'ayvakit_pp':[20,20,21,],
'ayvakit_tc':[23,24,6,20,7,],
'drug6_cs':[31,32,33,],
'drug5_tc':[25,25,26,25,27,28,25,29,30,],
'drug5_cs':[34,35,36,32,8,],
'drug3_cs':[1,1,4,4,5,9,],
'drug6_tc':[42,44,45,46,47,43,48,49,],
'drug1_cs':[15,16,18,],
'drug1_pp':[16,17,],
'drug1_tc':[6,7,16,9,19,8,],
'drug2_cs':[10,12,10,13,14,],
'drug2_pp':[10,11,6,],
'drug2_tc':[6,7,10,9,8,12,15,],
};
